module.exports = __webpack_public_path__ + "img/sw1-b3.edabf88c.jpg";